import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from '@/components/Layout';
import QuickWinsPage from '@/components/quick-wins/QuickWins';

const QuickWins = () => {
  return (
    <>
      <Helmet>
        <title>EPC Builder</title>
        <meta
          name="description"
          content="Improving your property's value, efficiency, and running costs with home upgrades"
        />
      </Helmet>
      <Layout title="EPC Builder Quick Wins">
        <QuickWinsPage />
      </Layout>
    </>
  );
};

export default QuickWins;
